function cov_25tj3wjj5o() {
  var path = "/app/src/components/installments-input/installments-input.tsx";
  var hash = "be42630337787bd0368299c6967bc9b5fb76ec02";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/installments-input/installments-input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 18
        },
        end: {
          line: 9,
          column: 19
        }
      },
      "1": {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 23
        }
      },
      "2": {
        start: {
          line: 25,
          column: 12
        },
        end: {
          line: 25,
          column: 23
        }
      },
      "3": {
        start: {
          line: 26,
          column: 22
        },
        end: {
          line: 28,
          column: 3
        }
      },
      "4": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 69
        }
      },
      "5": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      },
      "6": {
        start: {
          line: 44,
          column: 10
        },
        end: {
          line: 44,
          column: 26
        }
      }
    },
    fnMap: {
      "0": {
        name: "InstallmentsInput",
        decl: {
          start: {
            line: 19,
            column: 16
          },
          end: {
            line: 19,
            column: 33
          }
        },
        loc: {
          start: {
            line: 24,
            column: 10
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 24
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 22
          },
          end: {
            line: 26,
            column: 23
          }
        },
        loc: {
          start: {
            line: 26,
            column: 37
          },
          end: {
            line: 28,
            column: 3
          }
        },
        line: 26
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 43,
            column: 23
          },
          end: {
            line: 43,
            column: 24
          }
        },
        loc: {
          start: {
            line: 43,
            column: 38
          },
          end: {
            line: 45,
            column: 9
          }
        },
        line: 43
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 27,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 11
          },
          end: {
            line: 27,
            column: 23
          }
        }, {
          start: {
            line: 27,
            column: 28
          },
          end: {
            line: 27,
            column: 45
          }
        }, {
          start: {
            line: 27,
            column: 49
          },
          end: {
            line: 27,
            column: 67
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "be42630337787bd0368299c6967bc9b5fb76ec02"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25tj3wjj5o = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25tj3wjj5o();
import cn from 'classnames';
import React from 'react';
import NumberFormat from 'react-number-format';
import { Typography } from 'src/components/v2/typography';
import { useLocale } from 'src/hooks/use-locale';
import styles from './styles.css';
var MIN_VALUE = (cov_25tj3wjj5o().s[0]++, 0);
var MAX_VALUE = (cov_25tj3wjj5o().s[1]++, 99999);
export function InstallmentsInput(_ref) {
  var id = _ref.id,
    inputValue = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className;
  cov_25tj3wjj5o().f[0]++;
  var t = (cov_25tj3wjj5o().s[2]++, useLocale());
  cov_25tj3wjj5o().s[3]++;
  var checkLimits = function checkLimits(_ref2) {
    var value = _ref2.value;
    cov_25tj3wjj5o().f[1]++;
    cov_25tj3wjj5o().s[4]++;
    return (cov_25tj3wjj5o().b[0][0]++, value === '') || (cov_25tj3wjj5o().b[0][1]++, value > MIN_VALUE) && (cov_25tj3wjj5o().b[0][2]++, value <= MAX_VALUE);
  };
  cov_25tj3wjj5o().s[5]++;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "heading2",
    className: styles.title
  }, t('plan_your_budget')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: styles.description
  }, t('enter_your_purchase_amount_here')), /*#__PURE__*/React.createElement(NumberFormat, {
    id: id,
    className: cn(styles.calcInput, className),
    value: inputValue,
    onValueChange: function onValueChange(_ref3) {
      var value = _ref3.value;
      cov_25tj3wjj5o().f[2]++;
      cov_25tj3wjj5o().s[6]++;
      onChange(value);
    },
    thousandSeparator: ",",
    displayType: "input",
    decimalScale: 0,
    fixedDecimalScale: true,
    isAllowed: checkLimits,
    allowNegative: false,
    inputMode: "numeric"
  }));
}